import React from 'react';

import Backdrop from '../Backdrop/Backdrop';
import Aux from '../../../hoc/ReactAux/ReactAux';
import cartMark from 'images/cart-mark.png';
import './Modal.css';

const ModalSuccessPayment = props => {
  if (!props.showModal) {
    return null;
  }

  return (
    <Aux>
      <Backdrop show={true} />
      <div
        id="lb-placed"
        className="lb-geral lb-placed_ mfp-bg-login white-popup-block lb-centralizar singup zoom-anim-dialog Modal"
        tabIndex={0}
      >
        <div
          className="lb-padrao-singup6 mfp-content-login modal-content"
          tabIndex={0}
        >
          <button
            onClick={props.closeModal}
            type="button"
            className="bt-close mfp-close lb-fechar fa fa-times"
            ref={function(input) {
              if (input != null) {
                input.focus();
              }
            }}
            tabIndex={1}
          />
          <div className="check-mark">
            <img alt="cart-mark" src={cartMark} />
          </div>
          <div className="lb-content" tabIndex={0}>
            <span className="order">{props.descriptionSuccess}</span>
            {!!props.openReceipt && !props.isInvoice ? (
              <a onClick={props.openReceipt} className="view">
                View your receipt
              </a>
            ) : null}
            <a onClick={props.closeModal} className="bt" tabIndex={0}>
              Got it
            </a>
          </div>
        </div>
      </div>
    </Aux>
  );
};

export default ModalSuccessPayment;



// WEBPACK FOOTER //
// ./src/components/UI/Modal/ModalSuccessPayment.js